export default {
    // If no expression is provided, then auto-focus when the page is loaded
    inserted: function (el, binding) {
        if (typeof(binding.expression) === 'undefined') {
            el.focus();
        }
    },

    // Or focus based on a condition
    update: function(el, binding) {
        if (binding.value === true && binding.oldValue === false) {
            el.focus();
        }
    }
}
